const regex = /^\d{7,12}$/;

export const isIcCustomer = (id?: string) => {
  if (!id) {
    return false;
  }
  return regex.test(id);
};
